import { InjectionToken } from '@angular/core';
import { AuthGuardRoutes } from '@viso/core/models';

export const AuthGuardHelper = new InjectionToken<AuthGuardRoutes>(null);
